import { render } from "./ApplicationLogo.vue?vue&type=template&id=05837622"
import script from "./ApplicationLogo.vue?vue&type=script&lang=js"
export * from "./ApplicationLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__